import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

const TABLE = '/fase/';

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_fase == id})
    },
    isPlanificacaoAberta: (state) => (id) => {
        if(!id || state.data.length == 0) return;
        var fase = state.data.find((el)=>{ return (el.id_ano == id && el.tipo == 1) && ((new Date()) >= (new Date(el.data_inicio+' 00:00'))) && ((new Date()) <= (new Date(el.data_fim+' 23:59'))) });
        return (typeof fase != 'undefined') ? true : false
    },
    isReporteAberta: (state) => (id) => {
        if(!id || state.data.length == 0) return;
        var fase = state.data.find((el)=>{ return (el.id_ano == id && el.tipo == 2) && ((new Date()) >= (new Date(el.data_inicio+' 00:00'))) && ((new Date()) <= (new Date(el.data_fim+' 23:59'))) });
        return (typeof fase != 'undefined') ? true : false
    }
}

// actions
const actions = {

    get({ commit }) {
        return axios
            .get(TABLE)
            .then(res => {
                commit('setData', res.data.data || null)
            })
            .catch(err => {
                commit('setData', null)
            });
    },

    insert({ dispatch }, params) {
        
        return axios
            .post(TABLE, { ...params })
            .then(res => {
                if(!res.data.errors) {
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    update({ dispatch }, params) {
        return axios
            .put(TABLE, { ...params })
            .then(res => {
                if(!res.data.errors) {
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    delete({ dispatch }, {id}) {
        return axios
            .delete(TABLE+id)
            .then(res => {
                if(!res.data.errors){
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data ? data : [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/fases.js